<template>
  <ResidentialFloorDetail
    v-if="!!this.selectedData?.flat_id"
    @goBack="this.resetSelected"
    :activeData="this.selectedData"
    :params="this.filters"
    :updateData="this.onFLoorSchemaUpdated"
  />
  <div v-else class="wrapper">
    <q-linear-progress v-if="this.isFetching" indeterminate />
    <h1 class="title">Настройка объекта</h1>
    <div
      :style="(this.filters.entrance && !!this.filters.project_type_id) ? `width: calc(100% - 315px);` : 'width: 100%'"
    >
      <div class="header">
        <div class="filters">
          <div class="filters__item">
            <CustomSelect
              :options="this.residents"
              label="ЖК"
              optionValueKey="resident_id"
              optionLabelKey="resident_name"
              :value="this.filters.resident_id"
              @change="(value, row) => onFiltersChange('resident_id', value, row)"
            />
          </div>
          <div class="filters__item">
            <CustomSelect
              :options="this.entrances"
              label="Подъезд"
              optionValueKey="entrance"
              optionLabelKey="entrance_name"
              :loading="this.entrancesFetching"
              :value="this.filters.entrance"
              @change="(value, row) => onFiltersChange('entrance', value, row)"
            />
          </div>
          <div class="filters__item" style="width: 150px;">
            <CustomSelect
              :options="this.projectTypes"
              label="Тип проекта"
              optionValueKey="project_type_id"
              optionLabelKey="project_type_name"
              :value="this.filters.project_type_id"
              @change="(value, row) => onFiltersChange('project_type_id', value, row)"
            />
          </div>
        </div>
        <CustomDropdown
          v-if="!!this.filters.entrance && !!this.filters.project_type_id"
          :onClick="this.handleAction"
          :options="this.actions || []"
          title="Действия"
        />
      </div>
      <ResidentialApartmentsList
        :onApartmentClick="this.onApartmentClick"
        :floorsPlan="this.floorsPlan"
        :getFloorData="this.getFloorData"
        :isFetching="this.isFetching"
        :show="!!this.filters.entrance && !!this.filters.project_type_id"
        :createRemont="this.createRemont"
      />
    </div>
    <Legend
      v-if="!!this.filters.entrance && !!this.filters.project_type_id"
      :legend-fetching="this.legendFetching"
      :legend-info="this.legendData"
      :reload-data="this.getLegend"
    />
  </div>
</template>

<script>
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import CustomSelect from "@/components/form/CustomSelect";
import { MODAL_NAMES } from "@/constants";
import { appActions } from "@/services/store/modules/app_module/app_actions";
import ResidentialApartmentsList from './ResidentialApartmentsList.vue';
import ResidentialFloorDetail from './ResidentialFloorDetail.vue';
import Legend from './Legend.vue';
import CustomDropdown from "@/components/common/CustomDropdown";
import { createFloorRemont, getEntranceApartments, getEntranceLegendInfo, getResidentialEntrances, getResidentialSettingsList } from './services';
import { getProjectTypes } from "../ShellProjects/services";

export default {
  name: 'ResidentialSettings',
  components: {ResidentialApartmentsList, ResidentialFloorDetail, CustomSelect, Legend, CustomDropdown},
  data() {
    return {
      selectedData: null,
      isFetching: false,
      legendFetching: false,
      entrancesFetching: false,
      legendInfoClicked: false,
      projectTypes: [],
      residents: [],
      entrances: [],
      floorsPlan: [],
      legendData: [],
      floorParamData: [],
      filters: {
        resident_id: '',
        project_type_id: '',
        entrance: '',
      },
    };
  },
  methods: {
    handleAction(action) {
      if(!action?.onClick) return
      action.onClick()
    },
    getFloorData(floor = '') {
      if(!this.floorParamData?.length) return ''
      const data = this.floorParamData?.find(item => item.floor === floor)
      if(!data) return ''
      return data?.param_value || ''
    },
    async getProjectTypesData() {
      const res = await getProjectTypes()
      this.projectTypes = res || []
    },
    async getData() {
      const res = await getResidentialSettingsList()
      this.residents = res || []
    },
    async getEntrances(residentId) {
      this.entrancesFetching = true
      const res = await getResidentialEntrances(residentId)
      this.entrancesFetching = false
      this.entrances = res || []
    },
    async getFloorsPlan() {
      if(!this.filters.entrance || !this.filters.project_type_id) {
        this.floorsPlan = null
        this.legendData = null
        this.floorParamData = null
        return
      }
      this.isFetching = true
      const res = await getEntranceApartments(this.filters)
      this.isFetching = false
      this.floorsPlan = res?.data || []
    },
    async getLegend() {
      if(!this.filters.entrance || !this.filters.project_type_id) {
        this.legendData = null
        this.floorParamData = null
        return
      }
      this.legendFetching = true
      const res = await getEntranceLegendInfo(this.filters)
      this.legendFetching = false
      this.legendInfoClicked = true
      if(!res) return
      this.legendData = res?.data
      this.floorParamData = res?.floor_param_value
    },
    async createRemont(body) {
      if(!body) return
      const res = await createFloorRemont(this.filters, {...this.filters, ...body})
      if(!res) return
      this.$store.commit(appActions.closeModal());
      this.onFLoorSchemaUpdated()
      this.showSucceedSnackbar()
    },
    handleGrouping(wall) {
      this.$store.commit(appActions.showModal(MODAL_NAMES.RESIDENTIAL_GROUPING, {
        title: 'Смена группировки этажей',
        data: wall,
        mode: 'grouping',
        params: {...this.filters},
        onSubmit: (res) => {
          this.floorsPlan = res?.data
          this.legendData = res?.floor_param_types || []
        },
      }));
    },
    onFiltersChange(key, value, row) {
      this.filters[key] = value

      if(!!row)
        this.selectedData = this.selectedData ? {...this.selectedData, ...row} : {...row}

      if(key === 'resident_id') {
        this.filters.entrance = ''
        this.floorsPlan = null
        this.legendData = null
        this.floorParamData = null
        if(!!value)
          this.getEntrances(value)
        else {
          this.entrances = []
        }
      }
      if(key === 'entrance') {
        this.legendData = null
        this.floorParamData = null
        this.getFloorsPlan()
      }
      if(key === 'project_type_id') {
        if(this.filters.resident_id && this.filters.entrance) {
          this.legendData = null
          this.floorParamData = null
          this.getFloorsPlan()
        }
      }
    },
    onApartmentClick(apartment) {
      this.selectedData = {...this.selectedData, ...apartment}
    },
    onFLoorSchemaUpdated() {
      this.getFloorsPlan()
      if(this.legendInfoClicked)
        this.getLegend()
    },
    resetSelected() {
      this.selectedData = {...this.selectedData, flat_id: null, floor_map_id: null}
    }
  },
  computed: {
    actions() {
      return [
         {label: 'Изменить группировку', value: 'fill-params', disabled: !this.filters.entrance || !this.floorsPlan, onClick: this.handleGrouping},
      ]
    },
  },
  mounted() {
    this.getProjectTypesData()
    this.getData()
  },
  setup() {
    const {showErrorSnackbar, showSucceedSnackbar} = useCustomSnackbar();
    return {showErrorSnackbar, showSucceedSnackbar};
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  padding-top: 30px;
  position: relative;
}
.title {
  font-size: 30px;
  line-height: 37px;
  font-weight: 500;
  margin-bottom: 20px;
  margin-top: 0;
  margin-left: 20px;
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 15px;
  padding: 0 20px;
}
.filters {
  display: flex;
  align-items: flex-end;
  gap: 15px;
}
.filters__item {
  width: 220px;
}
</style>
